module.exports = __webpack_public_path__ + "static/media/atcoder.86fe6fa0.png";